import { withStyles } from "@mui/styles";
import { Tooltip } from "@mui/material";

export const WhiteOnBlackTooltip = withStyles({
  arrow: {
    color: "#323233",
  },
  tooltip: {
    color: "#ffffff",
    backgroundColor: "#323233",
    fontSize: "1em",
  },
})(Tooltip);

export const ParagraphTooltip = withStyles({
  arrow: {
    color: "#323233",
  },
  tooltip: {
    padding: "8px !important",
    color: "#ffffff",
    backgroundColor: "#323233",
    fontSize: "1em",
  },
})(Tooltip);
